import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import MoodleAdministrationPage from './pages/MoodleAdministrationPage';
import MoodleWizardPage from './pages/MoodleWizardPage';
import OdooCRMPage from './pages/OdooCRMPage';
import LMSPlatformPage from './pages/LMSPlatformPage';
import MigrationPage from './pages/MigrationPage';
import IntegrationsPage from './pages/IntegrationsPage';
import SupportPage from './pages/SupportPage';
import ConsultingPage from './pages/ConsultingPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import DataDeletionPage from './pages/DataDeletionPage';
import './styles/App.css';
import './styles/MoodleAdministration.css';
import './styles/OdooCRM.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/administracion-moodle" element={<MoodleAdministrationPage />} />
        <Route path="/configurar-moodle" element={<MoodleWizardPage />} />
        <Route path="/crm-canales-digitales" element={<OdooCRMPage />} />
        <Route path="/plataformas-lms" element={<LMSPlatformPage />} />
        <Route path="/migracion-consolidacion" element={<MigrationPage />} />
        <Route path="/integraciones-desarrollo" element={<IntegrationsPage />} />
        <Route path="/soporte-especializado" element={<SupportPage />} />
        <Route path="/capacitacion-consultoria" element={<ConsultingPage />} />
        <Route path="/politica-privacidad" element={<PrivacyPolicyPage />} />
        <Route path="/eliminacion-datos" element={<DataDeletionPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
